import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import {useLoginByPhoneContext} from '../LoginByPhoneContext';

const FieldPhone = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'register-form-phone',
    defaultMessage: 'Phone'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField<string>({name: 'phone'});
  const {gotCode} = useLoginByPhoneContext();

  return (
    <InputText
      {...field}
      {...meta}
      type={'phone'}
      variant={'full'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      placeholder={placeholder}
      disabled={gotCode}
    />
  );
};

export default FieldPhone;
